<template>
  <app-spinner v-if="loading > 0"></app-spinner>
  <main v-else>
    <div>
      <app-count-down v-if="getUtilisateurId" :formCountDown="false"/>
      <section class="introText text-center w-md-85 w-lg-65">
        <div class="animate__animated animate__backInDown">
          <h2>INFOTEXTO</h2>
          <h3>SOLUTIONS DE SMS MARKETING ET PRO</h3>
          <p>Plateforme de SMS Professionnel & Réalisation de campagne SMS</p>
        </div>
      </section>
      <nav class="d-flex flex-row flex-wrap justify-content-between mt-5">
        <template v-for="menu in getMenu">
          <router-link class="routerLink"
                       :to="menu.path"
                       v-if="$route.path !== menu.path">
            <button :class="'bButton ' + menu.class">
              <font-awesome-icon class="icon-menu" :icon="menu.icon"></font-awesome-icon>
              <span class="d-block">{{ menu.titre }}</span>
            </button>
          </router-link>
        </template>
      </nav>
    </div>
  </main>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
import CountDown from "./shared/CountDown";

export default {
  name: "Accueil",
  props: {},
  data () {
    return {
      loading: 0,
    }
  },
  components: {
    AppCountDown: CountDown,
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([
      'getMenu',
      'getUtilisateurId',
    ]),
  },
  watch: {},
  beforeCreate() {},
  created() {
/*
    if(this.$route.path === '/'){
      // alert("yesssssssssssssssss")
    }
*/
    // setTimeout( () => this.loading--, 1000)
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.animate__animated{
  --animate-duration: 1s;
  --animate-delay: 2s;
}
main {
  color: var(--color-second);
  background: var(--color-first);
  background-image: url(../assets/img/bg-4.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  & > div {
    padding: 3rem;
    background: var(--color-first-0-5);
    min-height: 70vh;
    & > nav{
      background: var(--color-first-0-5);
    }
    & > section.introText{
      background: var(--color-second);
      background-image: url(../assets/img/geometric.jpg);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      text-align: center;
      margin: 0 auto;
      & > div{
        background: var(--color-first-0-2);
        padding: 1rem .5rem;
        & > h2, & > h3, & > p{
          margin: 0;
          padding: 0;
          font-weight: bolder;
        }
        & > h2{
          margin-bottom: 1rem;
          color: var(--color-second-0-8);
          font-size: 3em;
        }
        & > h3{
          color: var(--color-fourth);
          font-size: 2em;
        }
        & > p{
          color: var(--color-seventh);
          padding: 1rem 2rem;
          font-size: 1.5em;
        }
      }
    }
    & > nav{
      padding: .5rem 1rem;
      & > .routerLink{
        margin: .5rem;
        & > .bButton{
          width: 120px;
          height: 90px;
          color: var(--color-first);
          border-color: var(--color-second);
          border-radius: .8rem;
          padding: 1rem;
          & > .icon-menu{
            font-size: 1.5rem;
          }
          & > span{
            font-size: x-small;
            font-weight: bold;
            text-transform: uppercase;
            margin-top: 1rem;
          }
        }
      }
      & > .routerLink:hover{
        & > .bButton{
          background: transparent;
          color: var(--color-second);
          & > .icon-menu{}
          & > h2{}
        }
      }
    }
  }
}

@media (min-width: 576px) {
  main {
    & > div {
      & > section, & > nav{}
      & > section.introText{
        & > div{
          & > h2, & > h3, & > p{}
          & > h2{}
          & > h3{}
          & > p{}
        }
      }
      & > nav{
        & > .routerLink{
          margin: .5rem;
          & > .bButton{
            width: 150px;
            height: 100px;
            padding: 1rem;
            & > .icon-menu{
              font-size: 1.5rem;
            }
            & > span{
              font-size: smaller;
              font-weight: bold;
              margin-top: 1rem;
            }
          }
        }
        & > .routerLink:hover{
          & > .bButton{
            & > .icon-menu{}
            & > h2{}
          }
        }
      }
    }
  }
}

@media (min-width: 768px) {
  main {
    & > div {
      & > section, & > nav{}
      & > section.introText{
        & > div{
          & > h2, & > h3, & > p{}
          & > h2{}
          & > h3{}
          & > p{}
        }
      }
      & > nav{
        padding: .5rem 2rem;
        & > .routerLink{
          margin: .5rem;
          & > .bButton{
            width: 195px;
            height: 130px;
            padding: 1rem;
            & > .icon-menu{
              font-size: 2rem;
            }
            & > span{
              font-size: large;
              font-weight: bold;
              margin-top: 1rem;
            }
          }
        }
        & > .routerLink:hover{
          & > .bButton{
            & > .icon-menu{}
            & > h2{}
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  main {
    & > div {
      & > section, & > nav{}
      & > section.introText{
        & > div{
          & > h2, & > h3, & > p{}
          & > h2{}
          & > h3{}
          & > p{}
        }
      }
      & > nav{
        padding: .5rem 2rem;
        & > .routerLink{
          margin: .5rem;
          & > .bButton{
            width: 220px;
            height: 130px;
            padding: 1rem;
            & > .icon-menu{
              font-size: 2rem;
            }
            & > span{
              font-size: large;
              font-weight: bold;
              margin-top: 1.5rem;
            }
          }
        }
        & > .routerLink:hover{
          & > .bButton{
            & > .icon-menu{}
            & > h2{}
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Accueil.vue